import { render, staticRenderFns } from "./rewardDiggingTreasureEdit.vue?vue&type=template&id=59660b96&scoped=true&"
import script from "./rewardDiggingTreasureEdit.vue?vue&type=script&lang=js&"
export * from "./rewardDiggingTreasureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59660b96",
  null
  
)

export default component.exports